import { useState } from "react";
import { Dropdown } from "../ui/dropdown/Dropdown";
import { getFullName } from "../../../utils/name";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { authService } from "../../../lib/api/apiService";

export default function UserDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading || !user) {
    return null;
  }

  const fullName = getFullName(user, "Utilisateur");
  const photo = user?.photo || null;
  const initials =
    fullName
      .split(" ")
      .map((part) => part.charAt(0).toUpperCase())
      .filter(Boolean)
      .slice(0, 2)
      .join("") || "U";

  const handleLogout = async () => {
    await authService.logout();
    window.location.href = "/vendor/login";
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-haspopup="true"
        className="dropdown-toggle flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-300"
      >
        {photo ? (
          <img
            src={photo}
            alt={fullName}
            className="h-full w-full object-cover"
          />
        ) : (
          initials
        )}
      </button>

      <Dropdown
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        className="w-56 !border-0 p-0 !shadow-md dark:!border-0"
      >
        <div className="px-4 py-3">
          <p className="truncate text-sm font-medium text-gray-900">
            {fullName}
          </p>
          {user?.email && (
            <p className="mt-0.5 truncate text-xs text-gray-500">
              {user.email}
            </p>
          )}
        </div>

        <button
          type="button"
          onClick={() => {
            setIsOpen(false);
            handleLogout();
          }}
          className="w-full px-4 py-2.5 text-left text-sm text-gray-700 hover:bg-red-100"
        >
          Se déconnecter
        </button>
      </Dropdown>
    </div>
  );
}
